export default "__VITE_ASSET__e985ad48__"